import React from "react";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { CustomCellRendererProps } from "ag-grid-react";

import { formatPercent } from "fond/utils/number";

import { getCellDiff } from "./comparisonDiff";

import { DiffCellContent, DiffLabel } from "./DiffCellRenderer.styles";

export interface DiffCellRendererParams extends CustomCellRendererProps {
  baselineColId: string;
}

export const DiffCellRenderer: React.FC<DiffCellRendererParams> = ({ api, node, value, valueFormatted, baselineColId }) => {
  const diff = getCellDiff(value, api, node, baselineColId);
  const isGrandTotal = node.data?.isGrandTotal;

  return (
    <DiffCellContent>
      {valueFormatted ?? "—"}
      {diff?.hasDiff && (
        <DiffLabel isIncrease={diff.isIncrease} onDark={isGrandTotal}>
          {diff.isIncrease ? <ArrowUpward /> : <ArrowDownward />}
          {formatPercent(Math.abs(diff.deltaPercent), 1)}
        </DiffLabel>
      )}
    </DiffCellContent>
  );
};
